import { GouvGeoAddress } from '../types/api/GeoAddress'

export const geoAddressTransformer = (address: GouvGeoAddress) => {
  return {
    ...address.properties,
    long: address.geometry.coordinates?.[0] ?? '',
    lat: address.geometry.coordinates?.[1] ?? '',
  }
}
